import { nextTick } from "vue";
import { storePromotion } from "../stores/promotion";

const getScrollTarget = (domObj) => {
  const target = domObj?.value ?? domObj;
  if (!target) return null;
  if (typeof target.scrollTo === "function") return target;
  if (typeof target?.wrapRef?.scrollTo === "function") return target.wrapRef;
  if (typeof target?.$el?.scrollTo === "function") return target.$el;
  return null;
};

export function smoothScrollTop(domObj) {
  nextTick(() => {
    const scrollTarget = getScrollTarget(domObj);
    if (!scrollTarget) return;
    scrollTarget.scrollTo({ top: 0, behavior: "smooth" });
  });
}

export function smoothScrollBottom(domObj) {
  nextTick(() => {
    const scrollTarget = getScrollTarget(domObj);
    if (!scrollTarget) return;
    scrollTarget.scrollTo({ top: scrollTarget.scrollHeight ?? 2000, behavior: "smooth" });
  });
}

export function getAssetsFile(url) {
  return new URL(`../assets/${url}`, import.meta.url).href;
}

export function getTipText(obj) {
  if (!obj) return "";
  if (!obj.content) return "";
  let ans = "";
  for (let i = 0; i < obj.content.length; i++) {
    ans = ans + (ans == "" ? "" : "\n") + joinWord_A(obj) + getContentConditionText(obj, i) + joinWord_B(obj) + joinWord_C(obj) + getContentDiscountText(obj, i) + joinWord_D(obj);
  }
  return ans;
}

const joinWord_A = (obj) => {
  if (obj.condition_type == "none") {
    switch (obj.target_products) {
      case "all":
        return "購買 任意商品 ";
      case "product":
        return "購買 指定商品 ";
      case "category":
        return "購買 指定分類商品 ";
    }
  } else if (obj.condition_type == "order") {
    return "訂單 購買 滿 ";
  } else if (obj.condition_type == "product") {
    return "購買 指定商品 滿 ";
  } else if (obj.condition_type == "category") {
    return "購買 指定分類的商品 滿 ";
  } else {
    return "";
  }
};

const joinWord_B = (obj) => {
  if (obj.condition_type == "none") {
    return "";
  } else {
    return obj.sub_condition == "money" ? " 元" : obj.sub_condition == "piece" ? " 件" : "";
  }
};

const joinWord_Target = (obj) => {
  if (obj.target_products == "product") {
    return "指定商品";
  } else if (obj.target_products == "category") {
    return "指定分類商品";
  } else {
    return "";
  }
};

const joinWord_C = (obj) => {
  if (obj.discount_type == "percent") {
    return "，" + joinWord_Target(obj) + " 每件再享 ";
  } else if (obj.discount_type == "money") {
    return "，" + joinWord_Target(obj) + " 每件再減NT$ ";
  } else if (obj.discount_type == "gift") {
    return "，" + joinWord_Target(obj) + " 即贈送 ";
  } else {
    return "";
  }
};

const joinWord_D = (obj) => {
  if (obj.discount_type == "percent") {
    return " 折優惠";
  } else if (obj.discount_type == "money") {
    return " 元";
  } else if (obj.discount_type == "gift") {
    return " 件贈品";
  } else {
    return "";
  }
};

const getContentConditionText = (obj, index) => {
  let ans = obj.content[index].condition == null ? "( ? )" : obj.content[index].condition;
  if (obj.condition_type == "none") {
    ans = "";
  }
  return ans;
};

const getContentDiscountText = (obj, index) => {
  if (obj.discount_type == "percent") {
    if (obj.content[index].discount == null) {
      return "( ? )";
    } else {
      if ((100 - obj.content[index].discount) % 10 == 0) {
        return (100 - obj.content[index].discount) / 10;
      } else {
        if (100 - obj.content[index].discount < 10) {
          return "0." + (100 - obj.content[index].discount);
        } else {
          return 100 - obj.content[index].discount;
        }
      }
    }
  } else {
    if (obj.discount_type == "special_price") {
      return "皆以 特價 販售";
    } else {
      return obj.content[index].discount == null ? "( ? )" : obj.content[index].discount;
    }
  }
};

export const getShippingFeeEventDescriptionText = (promotion) => {
  if (promotion.condition_type == "none") {
    return "購買任意商品即享免運費優惠";
  } else {
    let a = "";
    if (promotion.condition_type == "order") {
      a = "訂單購買滿 ";
    } else if (promotion.condition_type == "product") {
      a = "購買指定商品滿 ";
    } else if (promotion.condition_type == "category") {
      a = "購買指定分類商品滿 ";
    }
    const b = promotion.sub_condition == "money" ? " 元" : promotion.sub_condition == "piece" ? " 件" : "";

    return a + promotion.content[0].condition + b + "即享免運費優惠";
  }
};
